export default {
  filterSelectedAttachments(attachments) {
    if (!attachments || !attachments.length) {
      return ''
    }
    let result = []
    for (let attachment of attachments) {
      result = [...result, attachment.c_attachment.name]
    }
    return result
  },
  convertToArea(area) {
    const num = Number(area).toFixed(2)
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'ha'
  },
  convertToAreaWithoutUnit(area) {
    return Number(area).toFixed(2)
  },
  convertToYen(amount) {
    if (typeof amount === 'string' && amount.includes(',')) {
      amount = amount.replace(/,/g, '')
    }
    if (typeof amount === 'string') {
      amount = Number(amount)
    }
    if (!amount) {
      return amount + '円'
    } else {
      amount = String(amount)
      return Number(amount).toLocaleString() + '円'
    }
  },
  convertToYenWithoutUnit(amount) {
    if (!/^[0-9,]+$/.test(amount)) {
      return 0
    }
    if (typeof amount === 'string' && amount.includes(',')) {
      amount = amount.replace(/,/g, '')
    }
    if (typeof amount === 'string') {
      amount = Number(amount)
    }
    if (!amount) {
      return amount
    } else {
      amount = String(amount)
      return Number(amount).toLocaleString()
    }
  },
  convertToTon(weight) {
    const num = Number(weight).toFixed(2)
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 't'
  },
  convertToTonWithoutUnit(weight) {
    return Number(weight).toFixed(2)
  },
  convertToIntFromAmountString(amount) {
    if (String(amount).includes('円')) {
      return parseInt(amount.replace(/円$/, ''))
    }
    if (String(amount).includes(',')) {
      return parseInt(amount.replace(/,/g, ''))
    }
    return amount
  },
  convertToYear(amount) {
    return amount + '年'
  },
}
